import { toFixedNumber } from './helpers';

const CENTS = 100;

const CURRENCY_SYMBOLS = {
    USD: '$',
    EUR: '€'
};

const DEFAULT_CURRENCY = 'USD';

const getCurrencySymbol = currency => CURRENCY_SYMBOLS[currency] || CURRENCY_SYMBOLS[DEFAULT_CURRENCY];

const formatPrice = (priceInCents, currency) => `${getCurrencySymbol(currency)}${toFixedNumber(priceInCents / CENTS)}`;

export {
    getCurrencySymbol,
    formatPrice
};
